export const childAnimationVariants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { type: 'spring', stiffness: 40, velocity: -100, ease: 'easeIn' },
    },
  },
  closed: {
    y: 15,
    opacity: 0,
    transition: {
      y: { type: 'spring', stiffness: 50, velocity: -40 },
    },
  },
};

export const parentAnimationVariants = {
  open: {
    opacity: 1,
    visibility: 'visible',
    transition: { delayChildren: 0.07 },
  },
  closed: {
    opacity: 0,
    visibility: 'hidden',
  },
};
